import React, { useRef, useState } from "react";
import { Toast } from "./Toast";



export const ContactForm = () => {
	const formRef = useRef(null);
	const [isSuccess, setIsSuccess] = useState(null);
	const [isSending, setIsSending] = useState(false);

	const sheetsEndpoint = process.env.REACT_APP_SHEETS_ENDPOINT


	const sendEmail = async (e) => {
		e.preventDefault();
		setIsSuccess(null);
		setIsSending(true);

		try {
			if (!sheetsEndpoint) throw new Error("Sheets endpoint not configured");

			if (!formRef.current) throw new Error("Form reference is null");
			const formData = new FormData(formRef.current);
			const payload = {
				name: `DEVELOPMENT PORTFOLIO - ${formData.get("from_name")?.toString().trim()}` || "",
				email: formData.get("user_email")?.toString().trim() || "",
				message: formData.get("message")?.toString().trim() || "",
				timestamp: new Date().toISOString(),
			};

			// NOTE: with mode:"no-cors" the browser will always report
			// success (status = 0) if the request left the page.  
			// If you want a real 2xx/4xx status, update your Apps Script to
			// return CORS headers and drop "no-cors".
			await fetch(sheetsEndpoint, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(payload),
				mode: "no-cors",
			});
			setIsSuccess(true);
			if (formRef.current) formRef.current.reset();
		} catch (err) {
			console.error(err);
			setIsSuccess(false);
		} finally {
			setIsSending(false);
		}


	};

	return (
		<>
			<form
				ref={formRef}
				id="my-contact-form"
				onSubmit={sendEmail}
				className="flex flex-col text-coolGray-100 text-sm"
			>
				<div className="flex pb-3 mx-auto">
					<label className="pr-4">Name:</label>
					<input
						className="bg-transparent border border-b-coolGray-200 border-t-0 border-x-0 focus:outline-none"
						type="text"
						name="from_name"
						required
					/>
				</div>

				<div className="flex pb-7 mx-auto">
					<label className="pr-4">Email:</label>
					<input
						className="bg-transparent border border-b-coolGray-200 border-t-0 border-x-0 focus:outline-none"
						type="email"
						name="user_email"
						required
					/>
				</div>

				<div className="flex flex-col">
					<label className="pb-3 text-base font-bold">Message</label>
					<textarea
						className="min-w-[240px] bg-transparent border rounded border-coolGray-200 w-3/4 h-40 mx-auto focus:outline-none"
						name="message"
						required
					/>
					<button
						disabled={isSending}
						className="bg-coolGray-100 text-coolGray-900 rounded w-fit mx-auto p-2 mt-3 disabled:opacity-60"
						type="submit"
					>
						{isSending ? "Sending…" : "Send message"}
					</button>
				</div>
			</form>

			{isSuccess && <Toast.Success>Message sent</Toast.Success>}
			{isSuccess === false && <Toast.Danger>Error sending message</Toast.Danger>}
		</>
	);
};

export default ContactForm;
